import type { TRuleWithTheme } from '@/styles/theme';

export const hiddenButton: TRuleWithTheme = ({ theme }) => ({
    '&.ant-btn-text': {
        visibility: 'hidden',
        opacity: 0,
        padding: 0,
        margin: 0,
        lineHeight: 1,
        height: 'auto',

        transition: 'opacity 0.2s ease-in-out',
    },
});
